import { css, jsx } from '@emotion/core';
import { Avatar } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '@/styles';

const styles = {
  avatar: css`
    background-color: ${colors.accentGrayUltralight};
    color: ${colors.secondaryGrayDark};
    font-size: 3.5rem !important;
    flex: 0 0 84px;
  `,
};

const ContactInitials = props => {
  const { initials, icon } = props;
  const iconProp = !initials ? { icon } : {};
  return (
    <Avatar css={styles.avatar} size={84} {...iconProp}>
      {initials || ''}
    </Avatar>
  );
};

ContactInitials.propTypes = {
  initials: PropTypes.string,
  icon: PropTypes.string,
};

ContactInitials.defaultProps = {
  initials: '',
  icon: 'user',
};

export default React.memo(ContactInitials);
